<p-editor
  class="mt-3"
  [(ngModel)]="this.model"
  (ngModelChange)="this.isDirty = true;this.modelChange.emit($event)"
  (onInit)="this.onEditorInit($event)"
  [disabled]="this.disabled"
  [modules]="quillModules"
>
  <ng-template #header>
    @if(this.saveAble){
    <button
      type="button"
      class="pi pi-save ql-save align-middle"
      aria-label="Save"
      (click)="this.save()"
    ></button>
    }
    <span class="ql-formats">
      <select class="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <button
        type="button"
        class="ql-bold"
        aria-label="Bold"
      ></button>
      <button
        type="button"
        class="ql-italic"
        aria-label="Italic"
      ></button>
      <button
        type="button"
        class="ql-underline"
        aria-label="Underline"
      ></button><button
        type="button"
        value="ordered"
        class="ql-list"
        aria-label="Ordered List"
      ></button>
      <button
        type="button"
        value="bullet"
        class="ql-list"
        aria-label="Unordered List"
      ></button>
      <span class="ql-formats">
        <button
          type="button"
          class="ql-better-table-btn"
          aria-label="Insert Table"
          (click)="this.insertTable()"
        >
          <i class="pi pi-table"></i>
        </button>
      </span>
    </span>
    @if (this.isDirty && this.saveAble) {
    <span class="text-danger align-middle">
      <i class="pi pi-exclamation-triangle text-danger"></i>
      Nicht gespeichert!
    </span>
    }
  </ng-template>
</p-editor>